/**
 * 用户
 */

// 公共方法
import { setStoreApiDate } from '../utils'

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    // 用户登录
    async fetchUserLogin({ commit, getters }, params) {
      const { userLogin } = getters.getHttps
      const { data } = await userLogin(params,true)
      return setStoreApiDate(data, commit)
    },
  }
}
